export const agreements = [
  `Household Income - I understand I do not need to have documentation of all household
      members’ income when submitting this application and I can provide it at a later date.
      The CAP can determine when self-attestation (certification) alone is allowable.`,
  `Payment Request - I am seeking payment for the amounts past due and up to three months of
      rent, utilities, and/or other housing expenses. I understand that I can apply for future
      assistance payments three months at a time.`,
  `No Other Governmental Rental Assistance - No other governmental rental assistance will pay or
      has paid my past due rent and future rent. Financial assistance may be received from city/town
      welfare for rent requested in this application. However the rent paid with those funds will
      not be duplicated by NHERAP assistance.`,
  `NHERAP is a statewide program - Rockingham County may be providing a rental assistance program
      under the same federal law. If you are a resident of Rockingham County applying for assistance
      under NHERAP, you are certifying that you have not received benefits from the Rockingham
      County program.`,
  `I allow the Community Action Partnership (CAP) to which I am applying to collect and share my
      information with other programs within CAP and their outside partners, including but not
      limited to other NH CAPs, New Hampshire Housing Finance Authority, New Hampshire Employment
      Security, landlord, lessor, and utility provider for the purpose of assessing my needs for
      emergency housing, utility assistance, food, counseling, and/or other services and providing
      benefits.`,
  `I authorize New Hampshire Employment Security to provide information relative to my
      application for and receipt of unemployment benefits to New Hampshire Housing Finance
      Authority for purposes of determining eligibility for this program.`,
  `I understand that I will be screened for other program services and eligibility. I release the
      CAP and State of New Hampshire from any and all liability which may result from providing such
      information as it pertains to me or members of my household.`,
  `I certify that all information provided is correct and that failure to provide correct
      information or misrepresentation, falsifying or failure to disclose information could result
      in the household being denied emergency housing assistance.`,

  `I certify, attest, and affirm under penalty of perjury that the information presented in this
      application is complete and accurate to the best of my knowledge and belief. I authorize the
      US Department of Treasury, the New Hampshire Housing Finance Authority, and the State of New
      Hampshire to verify and investigate such information with my full cooperation at any time.`,

  `I understand that providing false or misleading statements or omissions to the United States
      government, the New Hampshire Housing Finance Authority, and the State of New Hampshire on
      this application and attestation may result in federal and state criminal and civil actions
      for fines, penalties, damages, or imprisonment.`,
];

export default agreements;
